'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$() {
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$__f_defaultMake$lzy2 = null;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$__f_defaultMakebitmap$2 = false;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$__f_make$lzy2 = null;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$__f_makebitmap$2 = false;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$__f_given_Show_Type$lzy2 = null;
  this.Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$__f_given_Show_Typebitmap$2 = false;
}
export { $c_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$ as $c_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$ };
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$.prototype.constructor = $c_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$;
/** @constructor */
function $h_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$() {
}
export { $h_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$ as $h_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$ };
$h_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$.prototype = $c_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$.prototype;
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$.prototype.defaultMake__Lyantl_INewtype$defaultMake$ = (function() {
  if ((!this.Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$__f_defaultMakebitmap$2)) {
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$__f_defaultMake$lzy2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$defaultMake$(this);
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$__f_defaultMakebitmap$2 = true;
  }
  return this.Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$__f_defaultMake$lzy2;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$.prototype.make__Lyantl_INewtype$make$ = (function() {
  if ((!this.Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$__f_makebitmap$2)) {
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$__f_make$lzy2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$make$(this);
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$__f_makebitmap$2 = true;
  }
  return this.Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$__f_make$lzy2;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$.prototype.resolveMake__Lyantl_Make = (function() {
  return this.defaultMake__Lyantl_INewtype$defaultMake$();
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$.prototype.protected_unwrap__O__O = (function(wrapped) {
  return wrapped;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$.prototype.wrap__O__O = (function(underlying) {
  return underlying;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$.prototype.validate__Lyantl_Validate = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validate$().Lyantl_Validate$__f_noOp;
});
$c_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$.prototype.given_Show_Type__Lcats_Show = (function() {
  if ((!this.Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$__f_given_Show_Typebitmap$2)) {
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$__f_given_Show_Type$lzy2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeUUID$$anon$1(this);
    this.Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$__f_given_Show_Typebitmap$2 = true;
  }
  return this.Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$__f_given_Show_Type$lzy2;
});
var $d_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$, "app.data.types_pharmacy$package$PharmacyUserId$", ({
  Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$: 1,
  Lyantl_INewtype: 1,
  Lyantl_Newtype: 1,
  Lyantl_Newtype$Of: 1,
  Lyantl_Newtype$WithoutValidation: 1,
  Lyantl_Newtype$WithoutValidationOf: 1,
  Lframework_utils_NewtypeUUID: 1
}));
export { $d_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$ as $d_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$ };
var $n_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$;
function $m_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$() {
  if ((!$n_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$)) {
    $n_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$ = new $c_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$();
  }
  return $n_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$;
}
export { $m_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$ as $m_Lapp_data_types\uff3fpharmacy$package$PharmacyUserId$ };
//# sourceMappingURL=app.data.types_pharmacy$package$-Pharmacy-User-Id$.js.map
